import React, { createContext, useContext, useState } from 'react';
import { toast } from 'react-hot-toast';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    try {
      setLoading(true);
      
      // Simulated API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      if (email && password) {
        setUser({ email });
        toast.success('Successfully logged in!');
        return true;
      }
      throw new Error('Invalid credentials');
    } catch (error) {
      toast.error(error.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const register = async (email, password, name) => {
    try {
      setLoading(true);
      
      // Simulated API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      if (email && password && name) {
        setUser({ email, name });
        toast.success('Successfully registered!');
        return true;
      }
      throw new Error('Registration failed');
    } catch (error) {
      toast.error(error.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    toast.success('Logged out successfully');
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
